import { GroupInquiryCriteriaList } from './groupInquiryCriteriaList';

export class SaveInquiryRules {
    groupName: string;
    criteriaList: GroupInquiryCriteriaList[];
    version: number;
}

